import React from "react";
import {Box, Checkbox, CircularProgress, FormControlLabel, FormGroup, Typography,} from "@mui/material";
import DpeScale2 from "../component/DpeScale2";
import ApartmentIcon from "@mui/icons-material/Apartment";
import StoreIcon from "@mui/icons-material/Store";
import OtherScale2 from "../component/OtherScale2";
import DpeCtrl from "../svc/openapi/DpeCtrl";
import OtherScale from "../component/OtherScale";

export default function DPEMenu() {

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    React.useEffect(() => {
        let id = params.get("code_iris");
        if(!id){
            id="132060602"
        }

        let copros = {}
        let personne = {}

        DpeCtrl.getStatsIris(id, res => {
            setPropCopro(res.propCopro)
            res.copros.forEach(copro => {

                if (copro.l_nom_copro) {

                    if (!copros[copro.cle_interop_adr]) {
                        copros[copro.cle_interop_adr] = []
                    }
                    copros[copro.cle_interop_adr].push(copro)
                }

                if (copro.personne_id) {

                    if (!personne[copro.cle_interop_adr]) {
                        personne[copro.cle_interop_adr] = []
                    }
                    personne[copro.cle_interop_adr].push(copro)
                }
            })


            setnbPropCopro(res.propCopro["A"] + res.propCopro["B"])
            let dpe = {A: 0, B: 0, C: 0, D: 0, E: 0, F: 0, G: 0, N: 0}
            let n = 0;
            Object.entries(res.dpeV2).forEach(([key, value]) => {
                dpe[key] = dpe[key] + value;
                n = n + value;
            })
            Object.entries(res.dpeV1).forEach(([key, value]) => {
                dpe[key] = dpe[key] + value;
                n = n + value;
            })
            setDpe(dpe)
            setNbDpesV2(n)

            setcst(res.periodesConstructions)
            n = 0;
            Object.entries(res.periodesConstructions).forEach(([key, value]) => {
                n = n + value;
            })
            setcstTotal(n)

            setGes(res.surfacesUtiles)
            n = 0;
            Object.entries(res.surfacesUtiles).forEach(([key, value]) => {
                n = n + value;
            })
            setNbGes(n)
            setTypeBat(res.typeBatiments)
            n = 0;
            Object.entries(res.typeBatiments).forEach(([key, value]) => {
                n = n + value;
            })
            setnbTypeBat(n)
            setLoading(false)
//            setDpeEnums(res)
        })
    }, [])
    const [loading, setLoading] = React.useState(true);

    const [typeBat, setTypeBat] = React.useState(undefined);
    const [nbTypeBat, setnbTypeBat] = React.useState(undefined);
    const [propCopro, setPropCopro] = React.useState(undefined);
    const [nbPropCopro, setnbPropCopro] = React.useState(undefined);
    const [filters, setFilters] = React.useState({
        dpe: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        dpeT: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        ges: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        surf: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        date: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
        typeSelBat: {A: true, B: true, C: true, D: true, E: true, F: true, G: true, N: true},
    });
    const [dpev2, setDpev2] = React.useState(false);
    const [dpev1, setDpev1] = React.useState(true);

    const [cst, setcst] = React.useState(0);
    const [cstTotal, setcstTotal] = React.useState(1);


    const [ges, setGes] = React.useState(undefined);
    const [nbGes, setNbGes] = React.useState(1);

    const [gesTer, setGesTer] = React.useState(undefined);
    const [nbGesTer, setNbGesTer] = React.useState(undefined);

    const [dpeTer, setDpeTer] = React.useState(undefined);
    const [dpe, setDpe] = React.useState(undefined);

    const [nbDpesV2, setNbDpesV2] = React.useState(1);

    function getDpeV1() {
        return (<FormGroup sx={{width: "100%", display: "flex", flexDirection: "row"}}>
            <FormControlLabel control={<Checkbox checked={dpev1} onClick={() => {
                setDpev1(!dpev1)
            }}/>} label="V1"/>
        </FormGroup>);
    }

    if (loading) {
        return (<Box sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center"
        }}>
            <CircularProgress/>
        </Box>)
    } else {
        return (
            <Box sx={{
                width: "90%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            }}>
                <Typography>
                    Indicateurs DataRenov pour le quartier sélectionné afin d'en évaluer le potentiel
                </Typography>
                <Box sx={{width: "100%", height: "100%", display: "flex"}}>
                    <Box sx={{width: "100%", height: "100%", display: "flex",  flexDirection: "column"}}>
                        <Box sx={{
                            width: "90%",
                            height: "100vh",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "nowrap",
                            alignItems: "flex-start"
                        }}>
                            <Box sx={{
                                width: "45%", display: "flex", marginTop: 2,
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <DpeScale2
                                    title={"DPE opposables"}

                                    scalecolor={{
                                        "A": "#168018",
                                        "B": "#43ce3f",
                                        "C": "#cefc43",
                                        "D": "#f7f72b",
                                        "E": "#f6c824",
                                        "F": "#f79b40",
                                        "G": "#f71e1a"
                                    }}
                                    text={{"A": "A", "B": "B", "C": "C", "D": "D", "E": "E", "F": "F", "G": "G"}}
                                    dpe={dpe}
                                    nbDpesV2={nbDpesV2}
                                    icon={<ApartmentIcon fontSize="small"/>}
                                    iconTer={<StoreIcon fontSize="small"/>}
                                />
                            </Box>

                            <Box sx={{
                                width: "45%", display: "flex", marginTop: 2,
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <OtherScale2
                                    title={"Surfaces Utiles"}
                                    size={130}
                                    scalecolor={{
                                        "A": "#DBDBDBFF",
                                        "B": "#DBDBDBFF",
                                        "C": "#DBDBDBFF",
                                        "D": "#DBDBDBFF",
                                        "E": "#DBDBDBFF",
                                        "F": "#DBDBDBFF",
                                        "G": "#DBDBDBFF"
                                    }}
                                    text={{
                                        "A": "<250 m²",
                                        "B": "251 & 500 m²",
                                        "C": "501 & 1000 m²",
                                        "D": "1001 & 1500 m²",
                                        "E": "1501 & 2000 m²",
                                        "F": "2001 & 2500 m²",
                                        "G": ">2501 m²"
                                    }}
                                    dpe={ges}
                                    dpeTer={gesTer}
                                    nbDpesV2={nbGes}
                                    nbDpesV2Ter={nbGesTer}

                                />
                            </Box>
                            <Box sx={{
                                width: "45%", display: "flex", marginTop: 2,
                                alignItems: "center",
                                justifyContent: "center"
                            }}>

                            <OtherScale2
                                    title={"Type de propriétaires"}
                                    size={130}
                                    scalecolor={{
                                        "A": "#DBDBDBFF",
                                        "B": "#DBDBDBFF"
                                    }}
                                    text={{
                                        "A": "Soc. ou collect.",
                                        "B": "Part. ou coprop."
                                    }}
                                    dpe={propCopro}
                                    nbDpesV2={nbPropCopro}
                                    icon={<StoreIcon fontSize="small"/>}
                                    changeState={(id) => {

                                        setFilters({...filters, propCopro: id});
                                    }}
                                />
                            </Box>
                            <Box sx={{
                                width: "45%", display: "flex", marginTop: 2,
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <OtherScale2
                                    title={"Type de batiment"}
                                    size={130}
                                    scalecolor={{
                                        "A": "#DBDBDBFF",
                                        "B": "#DBDBDBFF",
                                        "C": "#DBDBDBFF",
                                        "D": "#DBDBDBFF",
                                        "E": "#DBDBDBFF",
                                        "F": "#DBDBDBFF",
                                        "G": "#DBDBDBFF"
                                    }}
                                    text={{
                                        "A": "Secondaire",
                                        "B": "Dépendance",
                                        "C": "Ter. & Autres",
                                        "D": "Rés. collectif",
                                        "E": "Rés. individuel"
                                    }}
                                    dpe={typeBat}
                                    nbDpesV2={nbTypeBat}
                                    icon={<StoreIcon fontSize="small"/>}
                                />
                            </Box>
                            <Box sx={{
                                width: "45%", display: "flex", marginTop: 2,
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <OtherScale2
                                    title={"Périodes de construction"}
                                    size={100}
                                    scalecolor={{
                                        "A": "#DBDBDBFF",
                                        "B": "#DBDBDBFF",
                                        "C": "#DBDBDBFF",
                                        "D": "#DBDBDBFF",
                                        "E": "#DBDBDBFF",
                                        "F": "#DBDBDBFF",
                                        "G": "#DBDBDBFF"
                                    }}
                                    text={{
                                        "A": "< 1949",
                                        "B": "1949 à 1960",
                                        "C": "1960 à 1974",
                                        "D": "1975 à 1993",
                                        "E": "1994 à 2000",
                                        "F": "2001 à 2010",
                                        "G": "> 2011"
                                    }}
                                    dpe={cst}
                                    nbDpesV2={cstTotal}

                                />
                            </Box>
                        </Box>
                        <Box sx={{width: "100vw"}}>

                        </Box>
                    </Box>

                    <Box sx={{width: "20vw"}}/>
                </Box>
            </Box>)

    }
}
